// Variables
const header = document.querySelector(".site-header");

// On scroll check nav height and add class when window.scrollY > nav
window.addEventListener("scroll", function() {
    if(Math.floor(this.scrollY) > 0){
        header.classList.add("scroll-on");    
    } else {
        header.classList.remove("scroll-on");
    }
})